import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Divider, Box, Button } from '@mui/material';
import FlexCard from "../blocks/FlexCard.js";
import { useTheme } from '@mui/material/styles';
import { modifyColorOpacity } from "../../../helpers/index.js";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const Inspector = _ref => {
  let {
    cardData,
    featuredCard,
    featuredCardRenderer,
    heading,
    headingRenderer,
    theme,
    onHeaderActionClicked
  } = _ref;
  const defaultTheme = useTheme();
  const tg = theme || defaultTheme;
  const {
    inspector,
    singleFlexRow
  } = tg;
  const {
    heading: headingTheme,
    clearButton,
    featuredCard: featuredCardTheme,
    noData
  } = inspector || {};
  const {
    heading: fcThemeHeading,
    legend: fcThemeLegend
  } = featuredCardTheme || {};
  const featLegendColor = (featuredCard === null || featuredCard === void 0 ? void 0 : featuredCard.legendColor) || {};
  const noDataStyle = noData || {
    color: '#C8C8C8',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '70vh'
  };
  const renderHeading = () => {
    if (headingRenderer) {
      return headingRenderer();
    }
    if (!heading) {
      return null;
    }
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Box, {
        sx: singleFlexRow,
        children: [/*#__PURE__*/_jsx(Typography, {
          sx: headingTheme,
          children: heading
        }), /*#__PURE__*/_jsx(Button, {
          sx: clearButton,
          onClick: onHeaderActionClicked,
          color: "secondary",
          children: "Clear"
        })]
      }), /*#__PURE__*/_jsx(Divider, {})]
    });
  };
  const renderFeaturedCard = () => {
    if (featuredCardRenderer) {
      return featuredCardRenderer();
    }
    if (!featuredCard || !featuredCard.heading) {
      return null;
    }
    if (featuredCard.legendLabel) {
      const modifiedColor = modifyColorOpacity(featLegendColor, 1);
      fcThemeLegend.color = modifiedColor;
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs(Box, {
          sx: fcThemeHeading,
          children: [featuredCard.heading, ":"]
        }), /*#__PURE__*/_jsx(Box, {
          sx: fcThemeLegend,
          children: featuredCard.legendLabel
        })]
      });
    }
    return /*#__PURE__*/_jsx(Box, {
      sx: fcThemeHeading,
      children: featuredCard.heading
    });
  };
  const renderSingleCard = (card, index) => {
    return /*#__PURE__*/_jsx(FlexCard, {
      themeGroup: tg,
      item: card
    }, index);
  };
  if (!cardData || cardData.length === 0) {
    return /*#__PURE__*/_jsx(Box, {
      sx: noDataStyle,
      children: "Click a feature on the Map to view information"
    });
  }
  const renderCardData = cardData === null || cardData === void 0 ? void 0 : cardData.map((card, index) => {
    return renderSingleCard(card, index);
  });
  return /*#__PURE__*/_jsxs("div", {
    children: [renderHeading(), renderFeaturedCard(), renderCardData]
  });
};
Inspector.propTypes = {
  cardData: PropTypes.arrayOf(PropTypes.shape({
    heading: PropTypes.string,
    toolTip: PropTypes.string,
    legendLabel: PropTypes.string,
    legendColor: PropTypes.string,
    lines: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.any,
      link: PropTypes.string
    })),
    footerLinks: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      url: PropTypes.string
    }))
  })),
  heading: PropTypes.string,
  featuredCard: PropTypes.shape({
    heading: PropTypes.string,
    legendLabel: PropTypes.string,
    legendColor: PropTypes.string
  }),
  headingRenderer: PropTypes.func,
  featuredCardRenderer: PropTypes.func,
  theme: PropTypes.object,
  onHeaderActionClicked: PropTypes.func,
  children: PropTypes.node
};
export default Inspector;